const jquery = require('jquery');
window.$ = window.jQuery = jquery;
require('jquery-ui/dist/jquery-ui');
